import React,{useState} from 'react'

function Paging({pageprop,goBack,goNext}) {


  return (<div className='bg-yellow-300 my-2'>
    <div className='w-full flex justify-center mb-8 '>
      <button className='p-3 border-2 border-stone-400 text-stone-500 border-r-0 rounded-l-xl text-xl bg-white' 
      onClick={goBack}
      >
         Prev </button>
      <button className='p-3 border-2 border-stone-400 text-stone-500 bg-gray-200 text-xl'>
        {pageprop}
        </button>
      <button className='p-3 border-2 border-stone-400 text-stone-500 border-l-0 rounded-r-xl text-xl bg-white' 
      onClick={goNext}
      >
        next</button>

    </div>
    </div>
  )
}

export default Paging
